import React from "react";
import "./NavBar.css";

const LOGOS = [
  {
    src: "logos/Airwars.jpeg",
    alt: "Airwars",
    link: "https://airwars.org/investigations",
  },
];

export default function NavBar(props) {

  return (
    props.isMobile? (
    <div className="nav-bar-mobile">
      <div className="logos-container">
        {LOGOS.map((l) => (
          <img
            className="nav-logo-mobile"
            src={l.src}
            alt={l.alt}
            onClick={(e) => {
              e.preventDefault();
              console.log("button clicked");
              window.open(l.link, "_blank");
            }}
          ></img>
        ))}
      </div>
    </div>
  ):
  (    <div className="nav-bar">
  <div className="logos-container">
    {LOGOS.map((l) => (
      <img
        className="nav-logo"
        src={l.src}
        alt={l.alt}
        onClick={(e) => {
          e.preventDefault();
          console.log("button clicked");
          window.open(l.link, "_blank");
        }}
      ></img>
    ))}
  </div>
</div>) 
  )
}